module.exports = __webpack_public_path__ + "static/media/server_error.d4ee5bfd.png";